import Cookies from "js-cookie";

class Account {
    static getToken() {
        return localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    }

    static getAdminToken() {
        return localStorage.getItem('access_token') || '';
    }
    static getUrsToken() {
        return localStorage.getItem('access_token_urs') || '';
    }

    static getAdminRefreshToken() {
        return localStorage.getItem('refresh_token') || '';
    }

    static getUrsRefreshToken() {
        return localStorage.getItem('refresh_token_urs') || '';
    }

    static setAdminToken(token) {
        localStorage.setItem('access_token', token.access_token);
        localStorage.setItem('refresh_token', token.refresh_token);
    }
    static setUrsAdminToken(token) {
        localStorage.setItem('access_token_urs', token.access_token);
        localStorage.setItem('refresh_token_urs', token.refresh_token);
    }

    static logoutAdmin() {
        localStorage.removeItem('access_token_urs');
        localStorage.removeItem('refresh_token_urs');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        Cookies.remove('key')
        Cookies.remove('original')
        Cookies.remove('viewer')
        Cookies.remove('buddy')
        Cookies.remove('member')
        Cookies.remove('login')
        Cookies.remove('new')
        Cookies.remove('original')
    }

    static getIsAllowed() {
        return Cookies.get('isAllowed') === 'true';
    }

    static setIsAllowed(isAllowed) {
        Cookies.set('isAllowed', isAllowed ? 'true' : 'false', { expires: 30 });
    }
    static canWatch(userData){
        const { REACT_APP_SERVER } = process.env;
        if (REACT_APP_SERVER === "Beeline") {
            return true;
        }
        if (Cookies.get('isAllowed') === 'true' && Cookies.get('viewer')) {
            return false;
        }
        return Cookies.get('viewer') ? true : false;
    }
}

export default Account;
